<template>
	<div>
		<form @submit.prevent="sendFormData" v-if="items">
			<div class="row">
				<div class="col-lg-6">
					<h3>I. rész: Információk az elvégzendő feladatról és a feladatot végzőkről</h3>
					<div class="form-group">
						<label class="form-label">1.1 Helyszín:</label>
						<input type="text" class="form-control" disabled v-model="form_data.location_name">
						<input type="text" class="form-control border-warning" v-model="form_data.location_name_extension" placeholder="kiegészítés...">
					</div>
					<div class="form-group mt-2">
						<label class="form-label">1.2 Munkafolyamat leírása:</label>
						<textarea cols="30" rows="10" v-model="form_data.description" class="form-control border-warning"></textarea>
						<label class="form-label mt-1">1.2.1 Kiegészítő információk:</label>
						<div class="d-block mt-2">{{ task.description }}</div>
					</div>
					<div class="form-group mt-2">
						<label class="form-label">1.3 A beszállással végzendő feladat:</label><span class="badge bg-warning mx-1">Minimum egyet jelöljön ki</span>
						<div v-for="(item,id) in items.tasks" :key="id">
							<div class="input-group mb-1">
								<span class="input-group-text">
									<input type="checkbox" class="form-check-input" v-model="form_data.tasks[item.id].value">
								</span>
								<span class="input-group-text bg-white">
									{{item.name}}
								</span>
								<input v-if="item.with_text && form_data.tasks[item.id].value" type="text" v-model="form_data.tasks[item.id].text" class="form-control">
							</div>
						</div>
					</div>
					<div class="form-group mt-2">
						<label class="form-label">2. Használt felszerelések és munkaeszközök</label><br>
						<label class="form-label mt-3">Kommunikációhoz használt eszközök:</label>
						<textarea cols="30" rows="5" class="form-control border-warning" v-model="form_data.communication_tools"></textarea>
						<label class="form-label mt-2">Munkaeszközök:</label>
						<textarea cols="30" rows="5" class="form-control" v-model="form_data.work_tools"></textarea>
					</div>
					<div class="form-group mt-2">
						<label class="form-label">3.1 A munkavégzésben résztvevők</label>
						<table class="table">
							<thead>
								<tr>
									<th>Neve</th>
									<th>Feladata</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(permit,id) in permit_type.permits" :key="id">
									<td>{{permit.user_name}}</td>
									<td>{{permit_local_roles ? permit_local_roles.find(p => p.id == permit.local_role).name : ''}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<h3>III. rész Engedély érvényessége</h3>
					<label class="form-label">Ez az engedély a következő dátumtól érvényes:</label>
					<div class="row">
						<div class="col-md-8">
							<div class="form-group mt-2">
								<input type="date" class="form-control border-warning" v-model="start_date" :min="now">
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group mt-2">
								<input v-if="form_data.with_time" type="time" class="form-control border-warning" v-model="start_time">
							</div>
						</div>
					</div>
					<label class="form-label">Ez az engedély a következő dátumig érvényes:</label>
					<div class="row">
						<div class="col-md-8">
							<div class="form-group mt-2">
								<input type="date" class="form-control border-warning" v-model="end_date" :min="now">
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group mt-2">
								<input v-if="form_data.with_time" type="time" class="form-control border-warning" v-model="end_time">
							</div>
						</div>
					</div>
					<div class="form-check mt-2">
						<input class="form-check-input" :true-value="false" :false-value="true" type="checkbox" v-model="form_data.with_time" id="with_time_input" />
						<label class="form-check-label" for="with_time_input">Egész nap</label>
					</div>
				</div>
				<div class="col-lg-6">
					<h3>II. rész: Kockázatok azonosítása és kezelése</h3>
					<div class="form-group mt-2">
						<label class="form-label">4. Veszélyek, kockázatok megnevezése:</label><span class="badge bg-warning mx-1">Minimum egyet jelöljön ki</span>
						<div v-for="(item,id) in items.dangers" :key="id">
							<div class="input-group mb-1">
								<span class="input-group-text">
									<input type="checkbox" class="form-check-input" v-model="form_data.dangers[item.id].value">
								</span>
								<span class="input-group-text bg-white">
									{{item.name}}
								</span>
								<input v-if="item.with_text && form_data.dangers[item.id].value" type="text" v-model="form_data.dangers[item.id].text" class="form-control">
							</div>
						</div>
					</div>
					<h5>5. Nevezze meg valamennyi megelőző intézkedést, amit a munka megkezdése előtt, alatt és után el kell végezni, valamint a használni szükséges védőeszközöket!</h5>
					<div class="form-group mt-2">
						<label class="form-label">5.1 Légtérmérés</label>
						<div v-for="(item,id) in items.airspace" :key="id">
							<div class="input-group mb-1">
								<span class="input-group-text">
									<input type="radio" class="form-check-input" :value="item.id" v-model="form_data.airspace">
								</span>
								<span class="input-group-text bg-white">
									{{item.name}}
								</span>
							</div>
						</div>
					</div>
					<div class="form-group mt-2">
						<label class="form-label">5.2 egyéni védőeszközök</label>
						<div class="row" v-if="permit_type.permit_type == 2">
							<div class="col-lg-6" v-for="(item,id) in items.prevention" :key="id">
								<label class="form-label">{{item.name}}</label>
								<div v-for="(child_item,id) in item.items" :key="id">
									<div class="input-group mb-1">
										<span class="input-group-text">
											<input type="checkbox" class="form-check-input" v-model="form_data.prevention[item.id][child_item.id]">
										</span>
										<span class="input-group-text bg-white">
											{{child_item.name}}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div class="row" v-else>
							<div class="col-lg-6" v-for="(item,id) in items.prevention" :key="id">
									<div class="input-group mb-1">
										<span class="input-group-text">
											<input type="checkbox" class="form-check-input" v-model="form_data.prevention[id]">
										</span>
										<span class="input-group-text bg-white">
											{{item.name}}
										</span>
									</div>
							</div>
						</div>
						<div class="row">
							<div class="form-group">
								<label class="form-label">A beszálláshoz szükséges légzésvédő készülék, vagy túlnyomással működtetett frisslevegős készülék használhatósága kipróbálás után:</label>
								<select class="form-select" v-model="form_data.usable">
									<option :value="true">használható</option>
									<option :value="false">nem használható</option>
								</select>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Egyéb egyéni védőeszköz:</label>
								<textarea cols="30" rows="5" class="form-control" v-model="form_data.prevention[8]"></textarea>
							</div>
						</div>
					</div>
					<h5 class="mt-2">7. További megelőző intézkedések</h5>
					<div class="row">
						<div class="col-lg-6" v-for="(item,id) in items.needed_or_not" :key="id">
							<div class="form-group mt-2">
								<label class="form-label">{{item.name}}</label>
								<select class="form-select"  v-model="form_data.needed_or_not[item.id].value">
									<option :value="true">szükséges</option>
									<option :value="false">nem szükséges</option>
								</select>
								<div v-if="item.text">
									<label class="form-label">{{item.text}}</label>
									<input type="text" class="form-control" v-model="form_data.needed_or_not[item.id].text">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>
<script>
	import Task from "../../apis/Task";
	import Location from "../../apis/Location";
	import moment from 'moment';
	import Confirmation from "../../apis/Confirmation";
export default {
	props:{permit_type: Object, task: Object},
	data() {
		return {
			testvariable : true,
			form_data:{
				location_name: "",
				description: "",
				communication_tools: null,
				work_tools: null,
				tasks:[
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
				],
				dangers:[
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
				],
				airspace: 1,
				usable: true,
				prevention:[
					[false,false],
					[false,false],
					[false,false,false,false,false],
					[false,false],
					[false,false,false,false,false],
					[false,false,false,false,false],
					[false,false,false,false,false],
					[false,false,false],
					"",
				],
				needed_or_not:[
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
					{value: false, text:null},
				],
				with_time:false,
				location_name_extension:null,
			},
			start_date:null,
			start_time:null,
			end_date:null,
			end_time:null,
			permit_local_roles:false,
			items:false,
			completition_items:false,
			now:moment().format('YYYY-MM-DD')
		}
	},
	computed:{
		is_complete(){
			if(this.completition_items.filter(ci => ci.satisfied == false).length == 0 && this.datetime_complete){
				return true;
			}else{
				return false;
			}
		},
		datetime_complete(){
			if(this.start_date && this.end_date){
				if(this.form_data.with_time){
					if(this.start_time && this.end_time){
						return true;
					}else{
						return false;
					}
				}else{
					return true;
				}
			}else{
				return false;
			}
		}
	},
	watch: {
		form_data : {
			handler(){
				this.completition_items.forEach( ci => {
					switch(ci.type){
						case 1:
							if(this.form_data[ci.name].filter(i => i.value == true).length >= 1){
								this.$set(ci,'satisfied',true);
							}else{
								this.$set(ci,'satisfied',false);
							}
							break;
						case 2:
							if(this.form_data[ci.name]){
								this.$set(ci,'satisfied',true);
							}else{
								this.$set(ci,'satisfied',false);
							}
							break;
					}
				})
			},
			deep: true
		}
	},
	created() {
		if(this.permit_type.start_date_time){
			let start_moment = moment(this.permit_type.start_date_time);
			this.start_date = start_moment.format('YYYY-MM-DD');
			this.start_time = start_moment.format('HH:mm');
		}
		if(this.permit_type.end_date_time){
			let end_moment = moment(this.permit_type.end_date_time);
			this.end_date = end_moment.format('YYYY-MM-DD');
			this.end_time = end_moment.format('HH:mm');
		}
		Location.show(this.task.location_id)
		.then(response => {
			this.form_data.location_name = response.data.name;
		});
		if(this.permit_type.permit_type == 3){
			this.form_data.prevention = [false,false,false,false,false,false,false,false,""];
		}
		if(this.permit_type.form_data){
			this.form_data = this.permit_type.form_data;
		}
		this.permit_local_roles = JSON.parse(localStorage.getItem('constants')).permit_local_roles;
		this.items = JSON.parse(localStorage.getItem('constants')).permit_types.find(pt => pt.id == this.permit_type.permit_type).items;
		this.completition_items = JSON.parse(localStorage.getItem('constants')).permit_types.find(pt => pt.id == this.permit_type.permit_type).completition_items;
	},
	methods:{
		sendFormData(){
			if(!this.is_complete){
				Confirmation.swalCustomConfirm("Hiányos kitöltés","Mentés mindenképp","Így az engedély nem lesz kitöltött állapotú, a mégsem gombra kattintva folytathatod a kitöltést")
				.then(response => {
					if(response.isConfirmed === true){
						this.submitForm();
					}else{
						this.$emit('loadingstop');
					}
				});
			}else{
				this.submitForm();
			}
		},
		submitForm(){
			let start_date_time = this.start_date ? moment(this.start_date+((this.start_time && this.form_data.with_time) ? ' '+this.start_time : ' 00:00')).tz('Europe/Budapest').format() : this.start_date;
			let end_date_time = this.end_date ? moment(this.end_date+((this.end_time && this.form_data.with_time) ? ' '+this.end_time : ' 23:59')).tz('Europe/Budapest').format() : this.end_date;
			Task.sendPermitForm(this.task.id,this.permit_type.id,{form_data:this.form_data, is_complete:this.is_complete, start_date_time: start_date_time, end_date_time:end_date_time})
			.then(() => {
				this.$emit('closemodal','fill_detail_'+this.permit_type.id);
				this.$emit('iscomplete',this.is_complete);
				this.$emit('formdata',{
					form_data: this.form_data,
					start_date_time: start_date_time,
					end_date_time: end_date_time,
				});
			});
		}
	}
}

</script>